import { Injectable } from '@angular/core';
import { Config } from '../_store';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DateUtilsService {

  constructor() {
  }

  getCurrentTimeStamp() {
    return Date.now();
  }

  getToday() {
    return moment().startOf('day');
  }

  addDaysToDate(date, daysToAdd) {
    return moment(date).add(daysToAdd, 'day');
  }

  addYearsToDate(date, yearsToAdd) {
    return moment(date).add(yearsToAdd, 'year');
  }

  getFormattedDate(date = undefined) {
    return moment(date).format(this.getDateSaveFormat());
  }

  getFormattedDateForDisplay(date = undefined) {
    return moment(date).format(this.getDisplayFormat());
  }

  getFormattedDateForService(date) {
    return moment(date).format(Config.dateServiceFormat);
  }

  formatDate(date, dateFormat) {
    return moment(date).format(dateFormat);
  }

  getDateSaveFormat() {
    return Config.dateSaveFormat;
  }

  getDisplayFormat() {
    return Config.dateFormat;
  }

  getDateInMoment(date) {
    return moment(date);
  }

  getTimestamp(date?) {
    return moment(date).toDate().getTime();
  }

  getTimeStampFromMomentForPayments(dateMoment) {
    return this.getTimeStampForPayments(this.getFormattedDate(dateMoment));
  }

  // date - YYYY-MM-DD
  getTimeStampForPayments(date) {
    return new Date(date).getTime();
  }

  getDateFromTimestamp(timeStamp) {
    return moment.unix(timeStamp);
  }

  getDisplayDateFromTimestamp(timestamp) {
    return this.getFormattedDateForDisplay(this.getDateFromTimestamp(timestamp));
  }

  dateIsNotToday(date1) {
    return this.getDateDiff(this.getToday(), date1) !== 0;
  }

  getDateDiff(date1, date2) {
    return moment(date1).diff(moment(date2), 'day');
  }

  getOffsetDate(timestamp) {
    return moment(timestamp).utcOffset(330);
  }

  // date1 type is moment
  getStartOfDate(date1: moment.Moment, unit: moment.unitOfTime.StartOf = 'day') {
    return date1.startOf(unit);
  }

  getTimestampWithOffsetForTimeStamp(currTimestamp) {
    return this.getTimestamp(this.getStartOfDate(this.getOffsetDate(currTimestamp)));
  }

  cloneDate(dateToClone) {
    return moment(dateToClone).clone().toDate();
  }

  dateIsBetween(dateToCompare, fromDate, toDate) {
    return moment(dateToCompare).isBetween(this.getStartOfDate(moment(fromDate)), this.getStartOfDate(moment(toDate)), 'day', '[]');
  }

  convertDate(dateToConvert, dateFormat?) {
    return dateFormat ? moment(dateToConvert, dateFormat).startOf('day') : moment(dateToConvert).startOf('day')
  }

  // Date being sent from Service is not consistent, sometimes we get timestamp, sometimes YYYY-MM format, sometimes, MM-DD-YYYY
  convertDateUnknownFormat(dateToConvert) {
    const indexOfSeparator = dateToConvert.indexOf('-');
    if (indexOfSeparator === 4) {
      //YYYY-
      return moment(dateToConvert, 'YYYY-MM-DD HH:mm:ss');
    } else if (indexOfSeparator === 2) {
      // MM-DD
      return moment(dateToConvert, 'MM-DD-YYYY');
    } else {
      if (dateToConvert.toString().length === 8) {    // ddMMYYYY
        return moment(dateToConvert, 'DDMMYYYY');
      } else {
        // timestamp
        return this.getDateFromTimestamp(parseInt(dateToConvert) / 1000);
      }
    }
  }
  private rightOfString = (str, len) => {
    return str.substr(str.length - len)
  }

  getDateFromBootStrapDate(bootStrapDate) {
    const dateStr = `${bootStrapDate.year}-${this.rightOfString('00' + bootStrapDate.month.toString(), 2)}-${this.rightOfString('00' + bootStrapDate.day.toString(), 2)}`
    const date = moment(dateStr).startOf('day');
    return date;
  }

  getDateInMomentWithFormat(date, dateFormat = 'YYYY-MM-DD') {
    return moment(date, dateFormat);
  }

}

